// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardSection_container__3g0ml","label":"DashboardSection_label__1GO5h","wrapper":"DashboardSection_wrapper__1BPh2","divider":"DashboardSection_divider__34gWe"};